import { css } from '@emotion/react';
import styled from '@emotion/styled';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { memo } from 'react';

import Z_INDEX_SCALE from 'constants/zIndexScale';

const FooterBottom = dynamic(() => import('./FooterBottom'));
const FooterMain = dynamic(() => import('./FooterMain'));
const FooterMiddle = dynamic(() => import('./FooterMiddle'));
const FooterCloseButton = dynamic(() => import('./CloseButton'), {
  ssr: false,
});

const footerFixedStyles = ({ isFixed, isOpen }) =>
  isFixed &&
  css`
    bottom: ${isOpen ? '0' : '-9999px'};
    left: 0;
    z-index: ${Z_INDEX_SCALE.SIZE_5};
    position: fixed;
  `;

const StyledFooter = styled('footer')`
  ${({ theme }) => css`
    align-items: center;
    background-color: ${theme.colors.box.bg};
    border-top: ${theme.space[1]} solid ${theme.colors.base.blues.blue500};
    bottom: 0;
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;

    ${theme.mediaQueries.md} {
      display: flex;
    }
  `}
  ${footerFixedStyles}
`;

const Footer = ({ isActive, isFixed, isOpen, onClose, withCash3Section }) => {
  if (!isActive) {
    return null;
  }

  return (
    <StyledFooter isFixed={isFixed} isOpen={isOpen}>
      {isFixed && <FooterCloseButton onClick={() => onClose(false)} />}
      <FooterMain withCash3Section={withCash3Section} />
      <FooterMiddle />
      <FooterBottom />
    </StyledFooter>
  );
};

Footer.defaultProps = {
  isActive: true,
  isFixed: false,
  isOpen: true,
  onClose: () => {},
  withCash3Section: false,
};

Footer.propTypes = {
  isActive: PropTypes.bool,
  isFixed: PropTypes.bool,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  withCash3Section: PropTypes.bool,
};

export default memo(Footer);
